export enum UserRole {
    User = 'user',
    Curator = 'curator',
    Admin = 'admin'
}
